let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h1pGM")).then(() => parcelRequire('ghfmm'));